import { create } from 'zustand';

type ToastTone = 'success' | 'warning' | 'danger' | 'neutral';

export interface ToastItem {
  id: string;
  title: string;
  message: string;
  tone: ToastTone;
  action?: {
    label: string;
    onClick: () => void;
  } | undefined;
}

interface UiStore {
  toasts: ToastItem[];
  addToast: (toast: Omit<ToastItem, 'id'>) => void;
  dismissToast: (id: string) => void;
}

export const useUiStore = create<UiStore>((set) => ({
  toasts: [],
  addToast: (toast) =>
    set((state) => ({
      toasts: [
        ...state.toasts,
        {
          id: crypto.randomUUID(),
          ...toast
        }
      ]
    })),
  dismissToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id)
    }))
}));
